import React, { useRef, useImperativeHandle, forwardRef } from 'react'
import { ImageItem } from './ImageItem'
import { MasonryGrid } from './MasonryGrid'
import { VIEW_MODES } from '../constants'

export const ImageGrid = forwardRef(function ImageGrid({ 
  items, 
  viewMode, 
  onItemClick, 
  onScroll, 
  hasMore, 
  loading 
}, ref) {
  const gridContainerRef = useRef(null)
  
  // Expose scrollToTop method to parent
  useImperativeHandle(ref, () => ({
    scrollToTop: () => {
      if (gridContainerRef.current) {
        gridContainerRef.current.scrollTop = 0
      }
    }
  }))
  
  return (
    <div className="data-explorer__grid-container" onScroll={onScroll} ref={gridContainerRef}>
      <div className={`data-explorer__grid ${viewMode === VIEW_MODES.MASONRY ? '-masonry' : ''}`}>
        {viewMode === VIEW_MODES.MASONRY ? (
          <MasonryGrid items={items} onItemClick={onItemClick} />
        ) : (
          items.map((item, index) => (
            <ImageItem
              key={`${item.filename}-${index}`}
              item={item}
              onClick={onItemClick}
            />
          ))
        )}
      </div>
      
      {hasMore && !loading && (
        <div className="data-explorer__load-more">
          <p className="-small">Scroll for more...</p>
        </div>
      )}
    </div>
  )
})

